import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { createQuery } from '@farfetched/core';
import { getResidentAccounts } from './api';
import type {
  GetResidentAccountsPayload,
  GetResidentAccountsResponse,
  Props,
} from './types';

export const ResidentAccountsControlGate = createGate<Props>();

const fxGetResidentAccounts = createEffect<
  GetResidentAccountsPayload,
  GetResidentAccountsResponse,
  Error
>().use(getResidentAccounts);

export const residentAccountsQuery = createQuery({
  name: 'resident-accounts',
  effect: fxGetResidentAccounts,
  mapData: ({ result: { personal_account } }) =>
    Array.isArray(personal_account)
      ? personal_account.map((item) => ({
          id: item?.personal_account_id,
          label: item?.account_number,
          type: item?.account_type?.title,
          company: item?.resource_company?.title,
          inn: item?.resource_company?.inn,
        }))
      : [],
});

sample({
  clock: ResidentAccountsControlGate.state,
  source: {
    status: ResidentAccountsControlGate.status,
    state: ResidentAccountsControlGate.state,
  },
  filter: ({ status, state: { residentGuid, areaGuids } }) =>
    !!(status && residentGuid && areaGuids.length > 0),
  fn: ({ state: { residentGuid, areaGuids } }) => ({
    resident_guid: residentGuid,
    area_guids: areaGuids,
  }),
  target: residentAccountsQuery.start,
});

sample({
  clock: ResidentAccountsControlGate.close,
  target: residentAccountsQuery.reset,
});

sample({
  clock: residentAccountsQuery.finished.success,
  source: ResidentAccountsControlGate.status,
  filter: (isOpened) => !isOpened,
  target: residentAccountsQuery.reset,
});
